@if (history) {
  <div class="row">
    @if (history[1]) {
      <div class="col-xs-12 history-item">
        <table class="table table-sm">
          <tbody>
            @for (alarm of history[0]; track alarm) {
              <!--
              <h5>{{alarm.createdAt | amDateFormat:apiService.getDateFormat() + ' HH:mm'}} <small>{{alarm.createdAt | amTimeAgo:false}}</small></h5>
              <img src="https://s3.eu-west-2.amazonaws.com/4d-images-charts/alarm-{{alarm.id}}.png"/>
              -->
              <tr class="header">
                <td colspan=2> {{alarm.createdAt | amDateFormat:apiService.getDateFormat() + ' HH:mm'}} <small>{{alarm.createdAt | amTimeAgo:false}}</small></td>
                <td>{{alarm.findings}}</td>
              </tr>
              @for (item of alarm.history; track item) {
                <tr>
                  <td>{{item.action}}</td>
                  <td>{{item.value}}</td>
                  <td>{{item.createdAt | amDateFormat:apiService.getDateFormat() + ' HH:mm'}}</td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
    }
    @if (!history[1]) {
      <div class="col-xs-12">
        There is no alarm history.
      </div>
    }
  </div>
}
